import { gql } from "gql";

export const GET_ALL_PERSONS = gql(/* GraphQL */ `
  query GetAllPersonsForSelect {
    findPersons {
      content {
        id
        ...PersonName
        personType {
          code
        }
        avatar {
          ... on FileDto {
            link
          }
          ... on Hidden {
            ...Hidden
          }
        }
      }
    }
  }
`);
